import React from 'react'
import './footer.css'
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { contact } from '../../data/profile';

const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer__logo">
        BURAK SAĞ
      </a>

      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#educations">Education</a></li>
        <li><a href="#experiences">Experience</a></li>
        <li><a href="#skills">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <BsLinkedin />
        </a>
        <a href={contact.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <FaGithub />
        </a>
      </div>

      <div className="footer__copyright">
        <small>
          {new Date().getFullYear()} &copy; Burak Sağ. All rights reserved.
        </small>
      </div>
    </footer>
  );
}

export default Footer
